import fireEvent from './fireEvent'
import { CustomEvents } from '../constants/events'

export default () => {
  fireEvent(CustomEvents.customScroll)
}
